import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import EducacaoService from '../../../../../services/contasEducacao-auth';
import Despesa from './despesa';


const ListarDespesa = () => {

    const [despesas, setDespesas] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [despesa, setDespesa] = useState("");


    async function fetchDespesas() {
        const response = await EducacaoService.listarDespesa();
        if (response.data.length >= 1) {
            setDespesas(response.data)
            setVazio(false)
        } else {
            setDespesas([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setDespesa(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a Despesa?')) {
            await EducacaoService.deletarDespesa(id)
            alert("Despesa deletada com sucesso!")
            fetchDespesas();
        }
    }

    useEffect(() => {
        fetchDespesas();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/educacao/despesas/editar/${despesa}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setDespesas={setDespesas}
                        setVazio={setVazio}
                        fetchDespesas={fetchDespesas}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {despesas.map((despesa, index) =>
                                <Despesa
                                    fetchDespesas={fetchDespesas}
                                    despesa={despesa}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarDespesa;